export interface Chronicle {
  id: string;
  title: string;
  subtitle: string;
  dateRange: [number, number];
  region: string;
  regionId: string;
  coordinates: { x: number; y: number };
  description: string;
  themes: string[];
  available: boolean;
}

export const REGIONS = {
  lowCountries: { id: "lowCountries", name: "Low Countries", color: "hsl(43, 72%, 55%)" },
  iberia: { id: "iberia", name: "Iberian Peninsula", color: "hsl(0, 50%, 45%)" },
  scandinavia: { id: "scandinavia", name: "The Nordics", color: "hsl(200, 40%, 50%)" },
  italia: { id: "italia", name: "Italy", color: "hsl(15, 60%, 50%)" },
  france: { id: "france", name: "France", color: "hsl(220, 45%, 50%)" },
  britishIsles: { id: "britishIsles", name: "British Isles", color: "hsl(140, 30%, 45%)" },
  hre: { id: "hre", name: "Central Europe", color: "hsl(30, 50%, 45%)" },
  easternEurope: { id: "easternEurope", name: "Eastern Europe", color: "hsl(260, 30%, 45%)" },
  balkans: { id: "balkans", name: "Balkans", color: "hsl(350, 40%, 45%)" },
  panEuropean: { id: "panEuropean", name: "Pan-European", color: "hsl(45, 60%, 50%)" },
} as const;

export const ERAS = [
  { label: "Early Medieval", start: 476, end: 1000 },
  { label: "High Medieval", start: 1000, end: 1300 },
  { label: "Late Medieval", start: 1300, end: 1500 },
  { label: "Early Modern", start: 1500, end: 1789 },
  { label: "Age of Revolutions", start: 1789, end: 1848 },
  { label: "Industrial & National", start: 1848, end: 1914 },
  { label: "Age of World Wars", start: 1914, end: 1945 },
  { label: "Cold War", start: 1945, end: 1991 },
];
